import { timeline, stagger } from 'motion';

const html = document.querySelector('html'),
      pageHeader = document.querySelector('[data-page-header]'),
      pageNavigation = pageHeader.querySelector('[data-page-navigation]'),
      pageNavigationBg = pageNavigation.querySelector('[data-page-navigation-bg] span'),
      pageNavigationLinks = pageNavigation.querySelectorAll('[data-page-navigation-link]'),
      
      menuToggler = document.querySelector('[data-mobile-menu-trigger]'),
      [topBar, middleBar, bottomBar] = menuToggler.children,

      dekstopBreakPoint = 992;


let menuIsOpen = false;

const enterSequence = [
  [pageNavigation, { visibility: ['visible'], }, ],
  [pageNavigationBg,{ scale: [0, 1], }, { at: '<' },],
  [menuToggler, { color: '#dafda3' }, { at: '<' }],
  [middleBar, { scaleX: 0 }, { at: '<' }],
  [topBar, { y: [null, 8, null, null, null], rotate: [null, null, 45, null, null], scale: [null, null, null, 1.15, 1] }],
  [bottomBar, { y: [null, -8, null, null, null], rotate: [null, null, -45, null, null], scale: [null, null, null, 1.15, 1] }, { at: '-0.2' }],
  [pageNavigationLinks, { opacity: [0, 1] }, { delay: stagger(0.07), at: '<' }],
];

const exitSequence = [
  [pageNavigationBg, { scale: 0, },],
  [pageNavigationLinks, { opacity: 0 }, { at: '<' }],
  [menuToggler, { color: '#000' }, { at: '-0.2' }],
  [bottomBar, { y: [null, 0, null, null, null], rotate: [null, null, 0, null, null], scale: [null, null, null, 1.1, 1] }, { at: '<' }],
  [topBar, { y: [null, 0, null, null, null], rotate: [null, null, 0, null, null], scale: [null, null, null, 1.1, 1] }, { at: '-0.2' }],
  [middleBar, { scaleX: 1 }, { at: '<' }],
  [pageNavigation, { visibility: 'hidden' },],
];

const resetMenuToggle = [
  [menuToggler, { color: '#000' }, { at: '-0.2' }],
  [bottomBar, { y: [null, 0, null, null, null], rotate: [null, null, 0, null, null], scale: [null, null, null, 1.1, 1] }, { at: '<' }],
  [topBar, { y: [null, 0, null, null, null], rotate: [null, null, 0, null, null], scale: [null, null, null, 1.1, 1] }, { at: '-0.2' }],
  [middleBar, { scaleX: 1 }, { at: '<' }],
];

if (pageHeader && pageNavigation && menuToggler) {
  menuToggler.addEventListener('click', () => {
    const expanded = menuToggler.getAttribute('aria-expanded') === 'true';

    html.classList.toggle('is-fixed');
    menuToggler.setAttribute('aria-expanded', !expanded);

    if (!menuIsOpen) {
      timeline(enterSequence, { easing: [0.25, 0.1, 0.25, 1], duration: 1.5 });
    } else {
      timeline(exitSequence, { easing: [0.25, 0.1, 0.25, 1] });
    }

    menuIsOpen = !menuIsOpen;
  });
}

window.addEventListener('resize', () => {
  if (window.innerWidth > dekstopBreakPoint) {
    pageNavigation.style.visibility = '';
    pageNavigationLinks.forEach((e) => e.style.opacity = '');
    menuIsOpen = false;
    html.classList.remove('is-fixed');
    menuToggler.setAttribute('aria-expanded', false);
    timeline(resetMenuToggle, { easing: [0.25, 0.1, 0.25, 1] });
  }
});